﻿export enum BlobStatus {
    Drafting = 1,
    Authored = 2,
    Reviewed = 3,
    Approved = 4,
    Obsolete = 5
};

export const BLOB_STATUS_OPTIONS = [
    { label: 'Drafting', value: BlobStatus.Drafting },
    { label: 'Authored', value: BlobStatus.Authored },
    { label: 'Reviewed', value: BlobStatus.Reviewed },
    { label: 'Approved', value: BlobStatus.Approved },
    { label: 'Obsolete', value: BlobStatus.Obsolete },
];